/* @flow */
// Будем раскладывать элементы по слоям с помощью
// CSS свойства z-index.

const Layers = [
  "BACKGROUND",
  "CHART",
  "COVER",
  "INDICATOR",
  "TOOLTIP",
  "ZOOM",
  "SENTIMENTS"
].reduce((result, layer, index) => {
  result[layer] = index + 1;
  return result;
}, {});

export default Layers;



// WEBPACK FOOTER //
// ./src/components/Chart/Layers.js